export default __webpack_public_path__ + "static/media/login-icon6.57490f45.png";